/**
 * Entwicklungsmodus ohne Anmeldung.
 *
 * Eingeschaltet wird er ausschliesslich ueber `VITE_OHNE_ANMELDUNG=1` beim
 * Start des Entwicklungsservers. Zwei Sperren verhindern, dass er in eine
 * Auslieferung geraet:
 *
 *   1. `import.meta.env.DEV` — in einem Produktionsbau ist das false, die
 *      Bedingung faellt weg und der Zweig wird sogar herausoptimiert.
 *   2. Der zugehoerige Datenserver (`werkzeuge/dev-server.mjs`) beantwortet
 *      nur Anfragen mit `X-Mandant: DEV` und kennt keine Datenbank.
 *
 * In diesem Modus gibt es keinen Bestand, nur Wegwerf-Testdaten. Es ist
 * deshalb auch nichts abzugreifen.
 */

export const OHNE_ANMELDUNG: boolean =
  import.meta.env.DEV && import.meta.env['VITE_OHNE_ANMELDUNG'] === '1';

/** Mandant, der im Entwicklungsmodus gilt — es gibt dort nur diesen einen. */
export const DEV_MANDANT = 'dev';
